<section class="w-full h-full min-h-full box-border p-6 bg-background-default" data-testid="app-server-error">
  <div class="flex items-center h-full justify-center mat-app-background rounded-sm">
    <div class="add-new-item">
      <div class="add-new-item-icon">
        <img src="/assets/icons/empty_state/server_error.svg" alt="" data-testid="app-server-error-image" />
      </div>

      <div class="add-new-item-desc">
        <h6 class="add-new-item-desc-title" data-testid="app-server-error-title">
          {{ 'server_error.internal_server_error' | translate }}
        </h6>
        <div class="add-new-item-desc-text" data-testid="app-server-error-text">
          <span>{{ 'server_error.desc1' | translate }}</span>
          <span>{{ 'server_error.desc2' | translate }}</span>
        </div>
      </div>

      <claas-button class="w-max" (click)="reload()" data-testid="app-server-error-button"
        ><claas-icon iconId="648421" namespace="cc" [size]="22" iconStyle="bold" />{{
          'server_error.reload' | translate
        }}
      </claas-button>
    </div>
  </div>
</section>
